module.exports = __webpack_public_path__ + "media/assets/attachment_form-72db1872e74eef3fdd3475f989496d6d.svg";